module.exports = __webpack_public_path__ + "static/media/postgresql.7d56ed03.svg";